import { Component, OnInit } from '@angular/core';
import { Voucher } from 'src/app/models/point';
import { PointService } from 'src/app/services/point.service';
import { Router } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-redeem-popup',
  templateUrl: './redeem-popup.component.html',
  styleUrls: ['./redeem-popup.component.css']
})
export class RedeemPopupComponent implements OnInit {

  public voucher: Voucher;
  public message = '';
  public isSuccess: boolean;
  public modalRedeem = 'modal-redeem';
  public modalInfo = 'modal-info';

  constructor(
    private pointService: PointService,
    private router: Router
  ) { }

  ngOnInit() {
  }

  public showVoucher(voucher: Voucher): void {
    this.voucher = voucher;
    this.show();
  }

  public confirmRedeemVoucher() {
    const redeemParam = {
      voucher_merchant_id: this.voucher.voucher_id,
      point: this.voucher.point,
      category: this.voucher.category
    };

    this.hide();
    $('#loader').modal('show');
    this.pointService.postRedeemVoucher(redeemParam,
      data => {
        this.message = data;
        this.isSuccess = true;
        this.showInfo();
      },
      err => {
        if (err.code !== 417) {
          this.message = err.message;
          this.isSuccess = false;
          this.showInfo();
          return;
        }

        $('#loader').modal('hide');
      });
  }

  public show(): void {
    $('#' + this.modalRedeem).modal('show');
  }

  public hide(): void {
    $('#' + this.modalRedeem).modal('hide');
  }

  public showInfo(): void {
    $('#loader').modal('hide');
    $('#' + this.modalInfo).modal('show');
  }

  public hideInfo(): void {
    $('#' + this.modalInfo).modal('hide');
  }

  public goToReward(): void {
    this.hideInfo();
    this.router.navigate(['/reward']);
  }
}
